import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { AuthStore } from '../../core/stores/auth.store';
import { FormsModule } from '@angular/forms';
import { LoginPayload } from '../../core/models/auth';

@Component({
  selector: 'app-login',
  imports: [
    MatInput,
    MatFormField,
    MatLabel,
    MatButton,
    FormsModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent {
  username: string = '';
  password: string = '';

  store = inject(AuthStore);

  login() {
    const payload: LoginPayload = {
      user: this.username,
      password: this.password
    };
    this.store.login(payload);
  }
}
